import { ref, readonly } from 'vue';
import { post, get, ENDPOINTS } from '@/api/mainApi';
import store from '@/store';
import { SmsType } from '@/enums/smsType';

export function useSmsOperations() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const sendPaymentRequestSms = async (
    serialNumber: string,
    mobileNumber: string
  ): Promise<any> => {
    loading.value = true;
    error.value = null;

    try {
      const result = await post(
        `${ENDPOINTS.SMS}/${ENDPOINTS.SEND}/${ENDPOINTS.PAY_REQUEST}?serialNumber=${serialNumber}&mobileNumber=${mobileNumber}`,
        {}
      );
      return result;
    } catch (err) {
      error.value = 'Failed to send SMS';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const getLatestSmsStatus = async (serialNumber: string): Promise<any> => {
    loading.value = true;
    error.value = null;

    try {
      const result = await get(
        `${ENDPOINTS.SMS}/${ENDPOINTS.DONATION}/${serialNumber}/${ENDPOINTS.LATEST}/${SmsType.PAY_REQUEST}`
      );
      return result;
    } catch (err) {
      error.value = 'Failed to get SMS status';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    sendPaymentRequestSms,
    getLatestSmsStatus,
  };
}
